// src/AuthPopup.js


// src/AuthPopup.js
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook
import { useLocation } from 'react-router-dom';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { auth } from './firebase';
import Banner from './Banner'; // Import the Banner component
import { useMediaQuery } from 'react-responsive';
import './MBetaSignupPopup.css';
import PrimaryButton from './PrimaryButton';
import { db } from './firebase'; // Import your Firestore instance
import { collection, addDoc } from 'firebase/firestore';
import ReactPixel from 'react-facebook-pixel';
import { v4 as uuidv4 } from 'uuid'; // Import UUID generator
import TertiaryButton from './TertiaryButton'




function MBetaSignupPopup({ isVisible, onClose }) {
  const popupRef = useRef(null);
  const [message, setMessage] = useState(''); // State for error messages
  const [showMessage, setShowMessage] = useState(false); // State to control banner visibility
  const navigate = useNavigate(); // Hook to programmatically navigate
  const location = useLocation();
  const langPrefix = location.pathname.split('/')[1] || 'en';
  const isDesktop = useMediaQuery({ minWidth: 1024 });
  const [submitted, setSubmitted] = useState(false); // State to control banner visibility


  const [name, setName] = useState('New User')
  const [city, setCity] = useState('Beta')
  const [email, setEmail] = useState('')

  const submitRegistration = async (e) => {

    let dotCount = 0;
    const dots = ['.', '..', '...'];
    const eventId = uuidv4();

    // Start a timer to cycle through the dots
    const interval = setInterval(() => {
      dotCount = (dotCount + 1) % dots.length; // Cycle between 0, 1, 2
      setMessage(`Submitting${dots[dotCount]}`);
    }, 500); // Update every 500ms

    try {
      const docRef = await addDoc(collection(db, 'betaSignups'), {
        email: email,
        timestamp: new Date(),
        name: name,
        city: city,
      });
      console.log('Document written with ID: ', docRef.id);
      setShowMessage(true)
    } catch (e) {
      console.error('Error adding document: ', e);
    }

    const response = await fetch('https://jointly-api-274980191481.europe-west1.run.app/api/subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        first_name: name,
        email: email,
        event_id: eventId,
      }),
    });

    const data = await response.json();

    console.log(data)

    if (!response.ok || (data.status === 500)) {
      console.error('Failed to add subscriber to email sequence')
      clearInterval(interval);
      setMessage('');
      setName("New User")
      setCity("Beta")
      setEmail("")
    } else if (data.status === 201) {
      console.log('Already subscribed');
      clearInterval(interval);
      setMessage(langPrefix === 'nl' ? "Email in gebruik. Controleer uw email spam folder.." : 'Email already in use. Check your email spam folder..');
    } else if (data.status === 200) {
      console.log('Kit ok');

      clearInterval(interval);
      setSubmitted(true)
      window.fbq('track', 'Contact', {}, {
        'eventID': eventId
      })

      setName("New User")
      setCity("Beta")
      setEmail("")
    }
  };



  const [initialHeight, setInitialHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      // Only update height if the keyboard is NOT open (screen shrinking).
      if (window.innerHeight > initialHeight) {
        setInitialHeight(window.innerHeight);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [initialHeight]);


  useEffect(() => {

    if (isVisible) {

      const handleEscape = (event) => {
        if (event.key === 'Escape') {
          onClose();
        }
      };
      document.addEventListener('keydown', handleEscape);

      return () => {
        document.removeEventListener('keydown', handleEscape);
      };
    }
  }, [isVisible, onClose]);

  const handleOutsideClick = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      onClose();
    }
  };

  const availableTexts = {
    en: "🎉 Now Available!",
    fr: "🎉 C'est disponible!",
    nl: "🎉 Nu beschikbaar!"
  };

  const betaDescTexts = {
    nl: "Download de app gratis, ontdek leuke activiteiten, ontmoet nieuwe mensen en word deel van onze groeiende community.",
    en: "Download the app for free today to discover fun activities, to meet new people and to be part of our growing community.",
    fr: "Téléchargez l’application gratuitement, découvrez des activités et rencontrez de nouvelles personnes."
  };

  const loop = {
    nl: "Of blijf op de hoogte van updates:",
    en: "Or stay in the loop with updates:",
    fr: "Ou restez informé des nouveautés :"
  };

  const betaSubdescTexts = {
    nl: "Download de app nu via onderstaande links. We sturen je ook een mailtje, dus check zeker ook je spamfolder.",
    en: "Download the app now via the links below. You will also receive an email soon so be sure to check your spam folder.",
    fr: "Téléchargez l’application via les liens ci-dessous. Un email vous sera également envoyé, pensez à vérifier votre dossier spam."
  };

  return (
    <>
      {isVisible && (
        <div className="moverlay" onClick={handleOutsideClick}>
          <div className="mpopup"
            style={{ height: `${initialHeight * 0.8}px` }}
            ref={popupRef}>
            <button className="mclose-button" onClick={onClose}>X</button>
            <div className='mbeta-content-container'>


              {!submitted && (
                <>
                  <div className='mbeta-header-cont'>
                    <h3 className="mbeta-header-text">{availableTexts[langPrefix] || availableTexts['en']}</h3>
                  </div>

                  <div className='mbeta-desc-cont'>
                    <p className="mbeta-desc-text">{betaDescTexts[langPrefix] || betaDescTexts['en']}</p>
                  </div>

                  {/* <div className='mbeta-desc-cont'>
                    {langPrefix === 'nl' ? <p className="mbeta-desc-text">Download de app gratis, ontdek activiteiten, ontmoet nieuwe mensen en word deel van iets leuks.</p> : <p className="mbeta-desc-text"></p>}
                  </div> */}

                  <div className='mbeta-store-banners'>
                    <a href="https://apps.apple.com/be/app/jointlybe/id6741575789" target="_blank" rel="noopener noreferrer" className="mbeta-aas-wrapper" >
                      <img src='/assets/AppleAppStore_EN.svg' alt="Registrated" className="mbeta-aas" />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.joinjointly.jointlyapp" target="_blank" rel="noopener noreferrer" className="mbeta-gps-wrapper" >
                      <img src='/assets/GooglePlayStore_EN.png' alt="Registrated" className="mbeta-aas" />
                    </a>
                  </div>

                  <div className='mbeta-desc-cont2'>
                    <p className="mbeta-desc-text">{loop[langPrefix] || loop['en']}</p>
                  </div>

                  {/* <div className="mbeta-namecity-cont">
                    <input
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder={langPrefix === 'nl' ? "Voornaam" : "First Name"}
                      className='mbeta-name-form'
                    />
                    <input
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                      placeholder={langPrefix === 'nl' ? "Gemeente" : "City"}
                      className='mbeta-name-form'
                    />
                  </div> */}

                  <div className="mbeta-email-cont">
                    <input
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Email*"
                      className='mbeta-email-form'
                    />
                  </div>
                  <div className="mbeta-disc-cont">
                    <p className='mbeta-disc-text'>No spam. Unsubscribe at any time.</p>
                  </div>

                  <div className="mbeta-button-contFR">
                    <PrimaryButton text="Join Jointly" width="100%" height="100%" borderRadius={"8px"} fontSize={"4vw"} onLoginClick={submitRegistration} />
                  </div>
                  {showMessage && (
                    <div className="mbeta-message-cont">
                      <p className='mbeta-message-text'>{message}</p>
                    </div>)}
                </>
              )}

              {submitted && (
                <>
                  <div className='mbeta-subheader-cont'>
                    <h3 className="mbeta-subheader-text">
                      {langPrefix === 'nl' ? "Welkom bij Jointly! 🎉" :
                        langPrefix === 'fr' ? "Bienvenue sur Jointly ! 🎉" :
                          "Welcome to Jointly! 🎉"}
                    </h3>
                  </div>

                  <div className='mbeta-subdesc-cont'>
                    <p className="mbeta-subdesc-text">{betaSubdescTexts[langPrefix] || betaSubdescTexts['en']}</p>
                  </div>

                  {/* <div className="mbeta-check-cont">
                    <img src='/assets/blue_check.png' alt="Registrated" className="mbeta-check" />
                  </div> */}

                  <div className='mbeta-android-button'>
                    <a href="https://apps.apple.com/be/app/jointlybe/id6741575789" target="_blank" rel="noopener noreferrer" className="mbeta-aas-wrapper2" >
                      <img src='/assets/AppleAppStore_EN.svg' alt="Registrated" className="mbeta-aas" />
                    </a>
                  </div>

                  <div className='mbeta-ios-button'>
                    <a href="https://play.google.com/store/apps/details?id=com.joinjointly.jointlyapp" target="_blank" rel="noopener noreferrer" className="mbeta-aas-wrapper2" >
                      <img src='/assets/GooglePlayStore_EN.png' alt="Registrated" className="mbeta-aas" />
                    </a>
                  </div>



                </>
              )
              }


            </div>
          </div>
        </div>)}
    </>
  );
}

export default MBetaSignupPopup;

